import $ from 'jquery';

$(document).ready(function () {
    if(document.querySelector('.enquiry')){ initEnquiryForm(); }
})


function initEnquiryForm(){
    document.querySelector('.js-enquiry-submit').addEventListener('click', (event) => onEnquirySelectionChange(event));
}

function onEnquirySelectionChange(event) {

    resetBlocks();

    var enquiryDropdown =  document.querySelector('#enquirySelection')

    var element = document.querySelectorAll("[data-question='" + enquiryDropdown.value + "']");

    if (element.length > 0) {
        element[0].parentNode.classList.remove("enquiry-item--hide");
    }
}

function resetBlocks(){
    var resetContent = document.querySelectorAll('.enquiry-item__block')

    resetContent.forEach(function (element) {
        if (!element.parentNode.classList.contains('enquiry-item--hide')) {
            element.parentNode.classList.add("enquiry-item--hide")
        }

    })
}